// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'row-left-fill';

export const Component = () => (
  <path d='M.958 24.521s-.48-.096-.67-.287a.919.919 0 0 1-.288-.67V.957c0-.256.096-.48.287-.67A.919.919 0 0 1 .958 0h22.606c.256 0 .48.096.67.287a.919.919 0 0 1 .288.67v22.606a.919.919 0 0 1-.287.67.919.919 0 0 1-.67.288H.957Zm22.605-.958v-6.897H8.813v6.897h14.75Zm0-7.854V8.813H8.813v6.896h14.75Zm0-14.751H8.813v6.897h14.75V.958Z' />
);

export const viewBox = '0 0 25 25';
